module.exports = __webpack_public_path__ + "static/js/3.227ba585.chunk.worker.js"